// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */

.app-container {
  display: flex;
  height: 100vh;
  font-family: sans-serif;
  margin: 0;
  padding: 0;
}

/* Sidebar */
.sidebar {
  width: 220px;
  background-color: #f8f8f8;
  border-right: 1px solid #ddd;
  padding: 15px;
  box-sizing: border-box;
  overflow-y: auto;
}

.sidebar h2 {
  margin-top: 0;
}

.new-template-btn {
  width: 100%;
  margin-bottom: 10px;
  padding: 8px;
  cursor: pointer;
}

.template-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.template-list li {
  padding: 6px;
  cursor: pointer;
  border-radius: 4px;
  margin-bottom: 4px;
}

.template-list li:hover {
  background-color: #eee;
}

.template-list li.selected {
  background-color: #ddd;
  font-weight: bold;
}

/* Main content area */
.main-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

/* Toolbar */
.toolbar {
  padding: 10px;
  border-bottom: 1px solid #ddd;
  background-color: #fafafa;
}

.toolbar button {
  margin-right: 10px;
  padding: 8px 12px;
  cursor: pointer;
}

/* Editor area */
.editor-area {
  flex: 1 1;
  padding: 10px;
  overflow-y: auto;
  box-sizing: border-box;
}

.editor-area textarea {
  width: 100%;
  box-sizing: border-box;
  resize: vertical;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,YAAY;;AAEZ;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,UAAU;AACZ;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB","sourcesContent":["/* App.css */\n\n.app-container {\n  display: flex;\n  height: 100vh;\n  font-family: sans-serif;\n  margin: 0;\n  padding: 0;\n}\n\n/* Sidebar */\n.sidebar {\n  width: 220px;\n  background-color: #f8f8f8;\n  border-right: 1px solid #ddd;\n  padding: 15px;\n  box-sizing: border-box;\n  overflow-y: auto;\n}\n\n.sidebar h2 {\n  margin-top: 0;\n}\n\n.new-template-btn {\n  width: 100%;\n  margin-bottom: 10px;\n  padding: 8px;\n  cursor: pointer;\n}\n\n.template-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.template-list li {\n  padding: 6px;\n  cursor: pointer;\n  border-radius: 4px;\n  margin-bottom: 4px;\n}\n\n.template-list li:hover {\n  background-color: #eee;\n}\n\n.template-list li.selected {\n  background-color: #ddd;\n  font-weight: bold;\n}\n\n/* Main content area */\n.main-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n/* Toolbar */\n.toolbar {\n  padding: 10px;\n  border-bottom: 1px solid #ddd;\n  background-color: #fafafa;\n}\n\n.toolbar button {\n  margin-right: 10px;\n  padding: 8px 12px;\n  cursor: pointer;\n}\n\n/* Editor area */\n.editor-area {\n  flex: 1;\n  padding: 10px;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n\n.editor-area textarea {\n  width: 100%;\n  box-sizing: border-box;\n  resize: vertical;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
